module.exports = function moneyToFloat(number) {
  number = String(number);

  if (/^\-?[0-9]{1,3}(,?[0-9]{3})*(\.[0-9]+)?$/.test(number)) {
    return parseFloat(number.replace(',', ''));
  }

  if (/^\-?[0-9]{1,3}(\.?[0-9]{3})*(,[0-9]+)?$/.test(number)) {
    return parseFloat(number.replace('.', '').replace(',', '.'));
  }

  return 0.00;
}

